class ShippingEstimate extends HTMLElement {
  constructor() {
    super();

    // We are storing these in arrays, since it is possible rto include a range of two values, like [3,5].
    this.shippingDays1 = {
      ON: [5],
      QC: [5],
      AB: [6],
      BC: [6],
      MB: [7],
      NB: [7],
      NL: [7],
      NT: [7],
      NS: [7],
      NU: [7],
      PE: [7],
      SK: [7],
      YT: [7]
    };
    
    this.shippingDays2 = {
      ON: [4],
      QC: [4],
      AB: [5],
      BC: [5],
      NL: [6],
      MB: [6],
      NB: [6],
      NT: [6],
      NS: [6],
      NU: [6],
      PE: [6],
      SK: [6],
      YT: [6]
    };

    // If the customer is logged in, we are provided their province.
    this.province = this.dataset.customerProvince || null;
    
    this.estimateContainer1 = this.querySelector('.estimate-container-1');
    this.estimateContainer2 = this.querySelector('.estimate-container-2');

    if (this.province) {
      this.shippingRange1 = this.shippingDays1[this.province];
      this.shippingRange2 = this.shippingDays2[this.province];  
    } else {
      this.shippingRange1 = this.estimateContainer1?.dataset.shippingRange.split(",").map(Number);
      this.shippingRange2 = this.estimateContainer2?.dataset.shippingRange.split(",").map(Number);
    }

    let providerDates1,
        providerDates2
    
    if (this.shippingRange1.length) {
      providerDates1 = this.createEstimate(...this.shippingRange1);
    }
    if (this.shippingRange2.length) {
      providerDates2 = this.createEstimate(...this.shippingRange2);
    }

    this.estimateContainer1.innerHTML = providerDates1;
    this.estimateContainer2.innerHTML = providerDates2;
  }

  createEstimate(min, max) {
    if (!min && !max) {
      return
    }
    const DateTime = luxon.DateTime;
    const now = DateTime.now();
    
    let shippingDates;

    if (min && max) {
      shippingDates = `${now.plusBusiness({ days: min }).toLocaleString({ month: 'long', day: 'numeric' })} - ${now.plusBusiness({ days: max }).toLocaleString({ month: 'long', day: 'numeric' })}`;
    } else {
      shippingDates = `${now.plusBusiness({ days: min }).toLocaleString({ weekday: 'long', month: 'long', day: 'numeric' })}`;
    }
    
    return shippingDates
  }
}

customElements.define('shipping-estimate', ShippingEstimate);
